import api from "./ApiURLBase";
const EndPointGetPoints = async (miningSiteId, id = '', number = '', name = '', departmentId = '') => 
    await api.get(`/collectPoints/GetCollectPoints?miningSiteId=${miningSiteId}&id=${id}&number=${number}&name=${name}&departmentId=${departmentId}`);

const EndPointGetPointsEspecific = async (id, number, name, departmentId) =>
  await api.get(
    `/collectPoints/GetCollectPoints?collectPointId=${id}&nameDescription=${name}&numberDescription=${number}&departmentId=${departmentId}`
  );

const EndPointDeletePoint = async (id, miningSiteId) => await api.delete(`/collectPoints/DeleteCollectPoint/${(id)}/${miningSiteId}`);
const EndPointCreateUpdateVehiclePoint = async data => await api.post(`/collectPoints/CreateUpdateCollectPoint`, data);

//  ------------------------- Container ---------------------------------------
const EndPointGetContainers = async (id, miningSiteId) => await api.get(`/containers/GetContainer?collectPointId=${id}&miningSiteId=${miningSiteId}`);
const EndPointGetTypeContainer = async () => await api.get(`/containers/GetContainerModel`);
const EndPointGetTypeResidue = async () => await api.get(`/residual-subtypes/GetWasteSubType`);

const EndPointCreateUpdateCollectPoint = async data =>
  await api.post(`/containers/UpdateContainerCollectPoint`, {
    container: data
  });

export {
  EndPointGetPoints,
  EndPointDeletePoint,
  EndPointCreateUpdateVehiclePoint,
  EndPointGetContainers,
  EndPointGetTypeContainer,
  EndPointGetTypeResidue,
  EndPointCreateUpdateCollectPoint,
  EndPointGetPointsEspecific
};
